// src/components/perfil/Perfil.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import AppHeader from '../appHeader/appHeader';
import AppMenu from '../appMenu/appMenu';
import AppFooter from '../appFooter/appFooter';
import AppSetting from '../appSetting/appSetting';
import AppAdmin from '../appMenu/appAdmin';
import UserInfo from './components/UserInfo';
import EditProfileForm from './components/EditProfileForm';
import ChangePasswordForm from './components/ChangePasswordForm';
import UploadModal from './modals/UploadModal';

function Perfil() {
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState({
    nome: '',
    email: '',
    nome_fantasia: '',
    telefone1: '',
    telefone2: '',
    endereço: '',
    numero: '',
    complemento: '',
    uf: '',
    cidade: '',
    cep: '',
    cpf_cnpj: '',
    id: null,
  });
  const [newUser, setNewUser] = useState({
    nome: '',
    email: '',
    nome_fantasia: '',
    telefone1: '',
    telefone2: '',
    endereço: '',
    numero: '',
    complemento: '',
    uf: '',
    cidade: '',
    cep: '',
    cpf_cnpj: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);

  useEffect(() => {
      axios
        .post(
          '/api/get/user',
          {
            withCredentials: true,
          }
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            setAuthenticated(true);
            setUser(resp.data.user);
            setNewUser(resp.data.user);
            console.log(resp.data);
          } else {
            setAuthenticated(false);
          }
        })
        .catch((error) => {
          console.error('Erro na autenticação:', error);
          setAuthenticated(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    
  }, []);

  const updateUser = () => {
    axios
      .post(
        '/api/set/user',
        { ...newUser },
        {
          withCredentials: true,
        }
      )
      .then((resp) => {
        if (resp.data.status === 200) {
          window.location.reload();
        } else {
          alert(resp.data.erro);
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar perfil:', error);
        alert('Ocorreu um erro ao atualizar o perfil. Por favor, tente novamente.');
      });
  };

  const setPassword = (atual, password, confirmar) => {
    if (password === confirmar) {
      axios
        .post(
          '/api/set/password',
          { password, atual },
          {
            withCredentials: true,
          }
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            window.location.reload();
          } else {
            alert(resp.data.erro);
          }
        })
        .catch((error) => {
          console.error('Erro ao alterar senha:', error);
          alert('Ocorreu um erro ao alterar a senha. Por favor, tente novamente.');
        });
    } else {
      if (password === '') {
        alert("Por favor preencha o campo 'Senha Atual'");
      } else {
        alert('Você digitou a confirmação da senha incorretamente!');
      }
    }
  };

  const loadForm = (event) => {
    const { name, value } = event.target;
    if (name === 'telefone1' || name === 'telefone2') {
      // Remove tudo que não for número
      const numericValue = value.replace(/\D/g, '');

      // Formata o telefone
      let formattedValue = '';
      if (numericValue.length <= 10) {
        // Formatação para telefone de 10 dígitos (XXXXXXXXXX)
        formattedValue = numericValue.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else {
        // Formatação para telefone de 11 dígitos (XXXXXXXXXXX)
        formattedValue = numericValue.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }

      setNewUser((prevState) => ({
        ...prevState,
        [name]: formattedValue,
      }));
    } else {
      setNewUser((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  if (isLoading) {
    return (
      <div style={spinnerStyle}>
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    window.location.href = '/login';
    return null;
  }

  return (
    <>
      <section className="content">
        <div className="container-fluid" style={{ marginTop: 18 }}>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {/* Informações do Usuário */}
                    <div className="col-lg-4 col-md-12">
                      <UserInfo user={user} />
                    </div>
                    {/* Formulários de Edição */}
                    <div className="col-lg-8 col-md-12">
                      <div className="white-box">
                        <ul className="nav nav-tabs nav-tabs-light flex-center center-element" role="tablist">
                          <li role="presentation" className="nav-item">
                            <a
                              href="#primeira-aba"
                              className="nav-link active"
                              aria-controls="primeira-aba"
                              role="tab"
                              data-toggle="tab"
                              aria-expanded="true"
                            >
                              <span className="hidden-xs hidden-sm">
                                <i className="fa fa-user-circle" aria-hidden="true"></i> Editar Perfil
                              </span>
                            </a>
                          </li>
                          <li role="presentation" className="nav-item">
                            <a
                              href="#segunda-aba"
                              className="nav-link"
                              aria-controls="segunda-aba"
                              role="tab"
                              data-toggle="tab"
                              aria-expanded="false"
                            >
                              <span className="hidden-xs hidden-sm">
                                <i className="fa fa-lock" aria-hidden="true"></i> Alterar Senha
                              </span>
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content">
                          <EditProfileForm newUser={newUser} loadForm={loadForm} updateUser={updateUser} />
                          <ChangePasswordForm setPassword={setPassword} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Modais podem ser adicionados aqui, se necessário */}
      <UploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        handleUpload={(file) => {
          // Função para lidar com o upload
          console.log('Arquivo para upload:', file);
          setShowUploadModal(false);
        }}
      />
    </>
  );
}

// Estilos para o spinner de carregamento
const spinnerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

export default Perfil;
